import FollowUpRule from './FollowUpRule';
import SurveyQuestion from './SurveyQuestion';
import SurveyQuestionType from './SurveyQuestionType';

class SurveyQuestionChapterIntroduction extends SurveyQuestion {
  showInChapterList: boolean;

  chapterList: { id: string; title: string }[];

  constructor(
    questionId: string,
    questionType: SurveyQuestionType,
    title: string,
    description: string,
    group: string,
    variability: string,
    identifier: string,
    followUpRules: FollowUpRule[],
    imageIdentifier: string,
    chapterList: any,
    showInChapterList: boolean,
    info?: string,
    suffix?: string,
    allowSkipWithDefaultValue?: boolean
  ) {
    super(
      questionId,
      questionType,
      title,
      description,
      group,
      variability,
      identifier,
      followUpRules,
      imageIdentifier,
      info,
      suffix,
      allowSkipWithDefaultValue
    );

    this.chapterList = chapterList;
    this.showInChapterList = showInChapterList;
  }

  public static parseFromChapter(object: any, chapterList: {}[]) {
    return new SurveyQuestionChapterIntroduction(
      object.id,
      SurveyQuestionType.CHAPTER_INTRODUCTION,
      object.title,
      object.description,
      '',
      '',
      object.identifier,
      [],
      object.imageIdentifier,
      chapterList,
      object.showInChapterList,
      object.allowSkipWithDefaultValue
    );
  }
}

export default SurveyQuestionChapterIntroduction;
